import React from 'react'

function ThermostatIco({height="24px", width="24px", viewBox="0 -960 960 960", fill="#020317"}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox={viewBox}
      width={width}
      fill={fill}
    >
      <path d="M480-80q-83 0-141.5-58.5T280-280q0-48 21-89.5t59-70.5v-320q0-50 35-85t85-35q50 0 85 35t35 85v320q38 29 59 70.5t21 89.5q0 83-58.5 141.5T480-80Zm-40-440h80v-160h-80v160Zm40 360q50 0 85-35t35-85q0-31-13.5-57T555-386l-35-25v-269q0-17-11.5-28.5T480-720q-17 0-28.5 11.5T440-680v269l-35 25q-23 17-36.5 43T355-280q0 50 35 85t85 35Z"/>
    </svg>
  )
}

export default ThermostatIco
